module.exports = __webpack_public_path__ + "images/onboarding-banner/banner-wave-left.6dd6d2cc65ed2748a4d0.svg";